import { render, staticRenderFns } from "./announcementAdd.vue?vue&type=template&id=f19e76e2"
import script from "./announcementAdd.vue?vue&type=script&lang=js"
export * from "./announcementAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports